// removed by extract-text-webpack-plugin
module.exports = {"app":"_1DbhYPeVomOgezC3SShc04","confirmationIcon":"V0gGHmS7mOU_19mJbpNRK","confirmationBox":"_3dw1musIOq4yJLbg1wzbXV","confirmationCongrats":"_1gj28amuPJZ03tRt8u7FOA","confirmationInfo":"_1hxtzXCd25yRQz3yImXN48"};


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/App.css
 ** module id = 920
 ** module chunks = 1
 **/